<template>
  <b-nav-item-dropdown
    v-if="locales.length > 1"
    class="locale-switcher"
    :text="currentLocale"
    right
  >
    <b-dropdown-item v-for="locale in otherLocales" :key="locale" @click="currentLocale = locale">
      {{ $t(`locales.${locale}`) }}
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { localize } from "vee-validate";

export default {
  name: "NavbarLocaleSwitcher",
  data() {
    return {
      locales: ["fr", "en"],
    };
  },
  computed: {
    currentLocale: {
      get() {
        return this.$i18n.locale;
      },
      set(val) {
        this.$i18n.locale = val;
        localize(val);
      },
    },
    otherLocales() {
      return this.locales.filter((l) => l !== this.currentLocale);
    },
  },
};
</script>

<style>
.locale-switcher .dropdown-toggle {
  text-transform: uppercase;
}
</style>
